<template>
    <v-dialog v-model="$store.state.error" hide-overlay persistent max-width="600">
        <v-card class="px-5 py-5">
            <v-card-text style="text-align:center;"><h2>Error</h2></v-card-text>
            <v-card-text >
                <div style="text-align: center;">
                    {{$store.state.errorMsg}}
                </div>

                <div style="text-align:center" class="mt-3">
                    <v-btn color="darken-1" text @click="$store.state.error = false">Done</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name:"ErrorDialog"
    }
</script>
